import { useContext, useRef, useEffect } from 'react'
import RenderForm from '../../components/RenderForm/RenderForm'
import styles from './PreviewForm.module.css'
import { observer } from 'mobx-react-lite'
import { BuilderContext } from '../Sandbox/components/store/store.Builder'
import { WebSocketListener } from '../Sandbox/components/webSocket/WebSocketListener'

const PreviewForm = observer(() => {
  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  useEffect(() => {
    console.log(`PreviewForm render count: ${renderCountRef.current}`)
  })

  const builderContext = useContext(BuilderContext)

  return (
    <div>
      <WebSocketListener />

      <RenderForm
        DataForm={builderContext.styleForm}
        DataFields={builderContext.data.fields}
        isActiveSubmit={true}
        isFakeSubmit={true}
      />
    </div>
  )
})

export default PreviewForm
